<!--
일괄기능-컨트롤러
------------------------------------

-->
<template>
    <div class="house-header uk-flex uk-flex-between uk-flex-middle">
        <div class="checked-amount" >
            SELECTED QTY
            <span class="amount">{{ selectedQty }}</span>
            개
        </div>

        <!-- 정상버튼 -->
        <button
            v-show="itemCheckedCount > 0"
            class="uk-button uk-button-primary ok-button"
            @click="$refs.ok.setOk()"
        >
            <i class="material-icons">check</i>
            정상
        </button>

        <!-- 컴포넌트 -->
        <batch-ok
            ref="ok"
            :csrf-token="csrfToken"
            :prod-ids="checkedProdIds"
            :selected-qty="selectedQty"

            @check:exception="msg => $emit('check:exception', msg)"
            @done:pack="house_id => $emit('done:pack', house_id)"
            @done:ready="$emit('done:ready')"
        >
        </batch-ok>


        <div class="total-amount" >
            TOTAL QTY
            <span class="amount">{{ totalAmount }}</span>
            개
        </div>

        <div class="uk-width-expand">
        </div>

        <div class="house-name">
            {{ houseName }}
        </div>
        <div class="house-code">
            <a class="uk-link-reset" :href="'/houses/'+houseId+'/first-prod?tab=house-prod-info'" target="_blank" title="상세페이지">
                {{ houseCode }}
            </a>
        </div>


    </div>
</template>

<script>
    import checkedCountable from '../../../../batch/checked-countable';

    export default {
        mixins: [
            checkedCountable,
        ],
        components: {
            'batch-ok': require('./batch-ok.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            // 총 수량
            totalAmount: Number,

            // 수취인
            houseName: String,

            // 하우스ID
            houseId: Number,

            // 배송코드
            houseCode: String,
        },
        data: function () {
            return {
            };
        },
        computed: {
            /**
             * 선택된 수량합계
             * @return array
             */
            selectedQty() {
                // 선택 된 아이템만 필터
                return _.sumBy(this.checkedItems, 'amount');
            },

            /**
             * 선택된 상품번호배열
             * @return array
             */
            checkedProdIds() {
                // 선택 된 아이템만 필터
                return _.map(this.checkedItems, 'id');
            },
        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped>

    .house-header {
        padding: 5px;
        background-color: #333;
        //border-bottom: 1px solid #999;

        position: -webkit-sticky;
        position: sticky;
        top: 0;
    }

    .checked-amount {
        font-size: 1.25rem;
        color: #ddd;
        margin-right: 10px;
        .amount {
            font-size: 2rem;
            color: #FFFD7C;
        }
    }

    .total-amount {
        font-size: 1.25rem;
        color: #ddd;
        margin-left: 20px;
        .amount {
            font-size: 1.75rem;
            //color: #999;
        }
    }

    .house-name {
        font-size: 1.75rem;
        color: #FFFD7C;
        margin-right: 20px;
    }
    .house-code {
        font-size: 1.25rem;
        color: #ddd;
    }

    .ok-button {
        font-size: 1.5rem;
        .material-icons {
            font-size: 2rem;
        }
    }
</style>